module.exports = __webpack_public_path__ + "img/scrufy4.e652ee08.png";